import * as Sentry from "@sentry/sveltekit";

// If you don't want to use Session Replay, remove the `Replay` integration,
// `replaysSessionSampleRate` and `replaysOnErrorSampleRate` options.
Sentry.init({
    dsn: "https://45783c77baf5fc704767c2725bad8de9@o4505242737246208.ingest.us.sentry.io/4508773228806144",
    tracesSampleRate: 1
})

export const handleError = Sentry.handleErrorWithSentry();